const REGION_OPTIONS = [
  {key: '', value: null, text: ''},
  {key: 'R1', value: 'B', text: 'I'},

  {key: 'R2', value: 'N', text: 'II'},

  {key: 'R3', value: 'P', text: 'III'},
  {key: 'R4', value: 'A', text: 'IV'},

  {key: 'R5', value: 'C', text: 'V'},
  {key: 'R6', value: 'T', text: 'VI'},

  {key: 'R7', value: 'K', text: 'VII'},
  {key: 'R8', value: 'D', text: 'VIII'},

  {key: 'R9', value: 'F', text: 'IX'},
  {key: 'R10', value: 'S', text: 'X'},
];
export default REGION_OPTIONS;
